import {WZDownloadedFile} from "./types";

export function saveWZFile(file: WZDownloadedFile): void {
    const url = URL.createObjectURL(new Blob([file.blob], {type: 'application/octet-stream'}));
    const link = document.createElement('a');

    link.href = url;
    link.download = file.fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
